import Section from './Section'

export default class Ellipse extends Section {
  getBorderRadius() {
    return 10000
  }

  additionalStyles() {
    let {
      object: { attributes },
    } = this.props
    return {
      height: attributes.height,
    }
  }
}
